
/**
 * Compares two values to determine if they are deeply equal.
 *
 * @param {*} a - The first value to compare.
 * @param {*} b - The second value to compare.
 * @returns {boolean} Returns `true` if the values are deeply equal, otherwise `false`.
 */
export const deepEqual = (a, b) => {
    if (a === b) {
        return true;
    }

    if (a == null || typeof a != "object" || b == null || typeof b != "object") {
        return false;
    }

    const keysA = Object.keys(a), keysB = Object.keys(b);

    if (keysA.length !== keysB.length) {
        return false;
    }

    for (let key of keysA) {
        if (!keysB.includes(key) || !deepEqual(a[key], b[key])) {
            return false;
        }
    }

    return true;
}